import styled from "styled-components";
import { colors } from "@/theme";

export const ErrorMessageContainer = styled.div`
  width: 100%;
`;

export const ErrorMessageMessage = styled.p`
  width: 100%;
  color: ${colors.red};
  text-align: center;
  font-weight: bold;
`;
